/**
 * RequireAuth Guard
 * 
 * Ensures user is authenticated AND email verified before rendering children.
 * Returns null during loading, Navigate on failure, children on success.
 * 
 * Per Δ-B2: Email verification enforcement at guard level.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

export interface RequireAuthProps {
  children?: ReactNode;
  authenticated: boolean;
  emailVerified: boolean;
  loading: boolean;
  redirectTo?: string;
  verificationRedirect?: string;
}

export function RequireAuth({
  children,
  authenticated,
  emailVerified,
  loading,
  redirectTo = '/login',
  verificationRedirect = '/verify-email',
}: RequireAuthProps) {
  if (loading) {
    return null;
  }

  if (!authenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Δ-B2: Block /app/* access for authenticated but unverified users
  if (!emailVerified) {
    return <Navigate to={verificationRedirect} replace />;
  }

  return <>{children}</>;
}
